import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { products } from '../data/products';
import { getWhatsAppUrl, getEmailUrl } from '../utils/contact';

const Products = () => {
  return (
    <div className="products-page">
      <section className="products-hero">
        <div className="container split-section">
          <div>
            <p className="eyebrow">Products</p>
            <h1>Tools built for pharmacy, education, and regulatory teams.</h1>
            <p className="section-intro left">
              Explore specialized platforms designed to streamline learning, compliance, and
              documentation workflows for teams across the pharmaceutical ecosystem.
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">Request a Demo</Link>
              <a href={getEmailUrl('Product Inquiry')} className="btn btn-secondary">Email Us</a>
            </div>
            <div className="product-highlights">
              <div>
                <h3>Live + Beta</h3>
                <p>Access live tools or request early access for beta programs.</p>
              </div>
              <div>
                <h3>Secure Workflows</h3>
                <p>Designed for documentation, audits, and institutional reporting.</p>
              </div>
            </div>
          </div>
          <div className="section-visual">
            <img src="/images/tech-lagos.jpg" alt="Nigerian professional working on software tools" />
          </div>
        </div>
      </section>

      <section className="products-grid-section section-surface">
        <div className="container">
          <h2>Featured Platforms</h2>
          <p className="section-intro">
            Each product is purpose-built for a specific workflow. Pick the one that matches your
            team’s needs or talk to us for guidance.
          </p>
          <div className="products-grid">
            {products.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>

      <section className="products-support">
        <div className="container">
          <div className="support-card">
            <div>
              <h2>Need help choosing?</h2>
              <p>
                Tell us your goals and we will recommend the right product, integrations, and rollout plan.
              </p>
            </div>
            <div className="cta-buttons">
              <a href={getWhatsAppUrl('I need help choosing the right ProgrammoCeuticals product')} className="btn btn-primary">WhatsApp</a>
              <a href={getEmailUrl('Help choosing a product')} className="btn btn-secondary">Email</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
